export default __webpack_public_path__ + "static/media/error-icon.9e815db8.svg";